import { Brick, BrickContext, registerBrick, Query } from 'olympe';
import InspectionResultMapping from '../../../models/InspectionResultMapping';
import Observation from '../../../models/Observation';
import Unit from '../../../models/Unit';

export default class LoadUnitObservation extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} unit
     * @param {function()} forwardEvent
     * @param {function(*)} setLoadedUnit
     */
    async update($, [unit], [forwardEvent, setLoadedUnit]) {
        const observations = unit
            .follow(Unit.observationsRel)
            .andReturn()
            .follow(Observation.evalutationRel)
            .andReturn()
            .execute();

        const mapping = Query.instancesOf(InspectionResultMapping).execute();
        // Keep them in cache, avoid garbage collection until clear of this brick:
        const key = `load_evaluation_of_unit_${unit.getTag()}`;
        $.set(key, await Promise.all([observations, mapping]));
        $.onClear(() => $.remove(key));
        setLoadedUnit(unit);
        forwardEvent();
    }
}

registerBrick('018a02bccc0ef89727d2', LoadUnitObservation);
